import { createFeatureSelector, createSelector } from '@ngrx/store'
import { BreakpointState } from '@angular/cdk/layout'

export const isMobileName = 'isMobile'

const isMobileFeature = createFeatureSelector<BreakpointState>(isMobileName)
export const isMobile = createSelector(isMobileFeature, (state: BreakpointState) => {
	return state.matches
})
